import AppHeaderLogo from './header-logo-light-rebrand.svg';
import SetupPageLogo from './shipstation-logo-black-rebrand.svg';

export const Logos = {
  AppHeaderLogo,
  SetupPageLogo,
};
